export const SEND_ERROR_SUCCESS = ' SEND_ERROR_SUCCESS';
export const SEND_ERROR_ERROR = 'SEND_ERROR_ERROR';
